"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateSubscription = exports.updateCustomerAddress = exports.unsuccessfulResponseHandler = exports.successfulStripeResponseHandler = exports.successfulResponseHandler = exports.setBaseUrl = exports.setAuthorizationHeader = exports.logAnalytics = exports.formUrlencodedHeaders = exports.fetchSharedTranslations = exports.fetchSetupIntent = exports.fetchPopups = exports.fetchPlans = exports.fetchLinks = exports.fetchConfigFile = exports.fetchConfig = exports.fetchBrandTranslations = exports.deleteCustomer = exports.createSubscription = exports.changeSubscriptionActivation = exports.authRefresh = exports.authMe = exports.authLogout = exports.authLogin = exports.attachPaymentMethod = exports.assignGlobalBrandParam = exports.apiRequest = exports.apiHeaders = void 0;
var _axios = require("../utils/axios");
var _config = require("../config");
const apiHeaders = exports.apiHeaders = {
  Accept: 'application/json',
  'Content-type': 'application/json',
  'X-Requested-With': 'XMLHttpRequest'
};
const formUrlencodedHeaders = exports.formUrlencodedHeaders = {
  'Content-type': 'application/x-www-form-urlencoded'
};
const apiRequest = exports.apiRequest = _axios.axios.create({
  headers: apiHeaders,
  baseURL: _config.apiBaseUrl
});
const setBaseUrl = url => {
  apiRequest.defaults.baseURL = url;
};
exports.setBaseUrl = setBaseUrl;
const setAuthorizationHeader = token => {
  apiRequest.defaults.headers.common.Authorization = `Bearer ${token}`;
};
exports.setAuthorizationHeader = setAuthorizationHeader;
const successfulResponseHandler = response => [null, response && response.data !== undefined ? response.data : response];
exports.successfulResponseHandler = successfulResponseHandler;
const successfulStripeResponseHandler = response => [null, response && response.data && response.data.data !== undefined ? response.data.data : null];
exports.successfulStripeResponseHandler = successfulStripeResponseHandler;
const unsuccessfulResponseHandler = error => [error, null];
exports.unsuccessfulResponseHandler = unsuccessfulResponseHandler;
const assignGlobalBrandParam = (axiosInstance, brandId) => axiosInstance.interceptors.request.use(config => {
  const isSharedRequest = config.url.includes('brand/links');
  const isBrandConfigRequest = config.url.includes('brands/');
  const isExceptedRequest = isSharedRequest || isBrandConfigRequest;
  return {
    ...config,
    params: isExceptedRequest ? {} : {
      ...config.params,
      brand_id: brandId
    },
    data: isExceptedRequest ? {} : {
      ...config.data,
      brand_id: brandId
    }
  };
}, error => Promise.reject(error));
exports.assignGlobalBrandParam = assignGlobalBrandParam;
const fetchConfigFile = () => {
  const htmlPart = /\/[a-z]*\.html/;
  return _axios.axios.create({
    headers: apiHeaders,
    baseURL: window.location.pathname.replace(htmlPart, '')
  }).get('/config.json').then(successfulResponseHandler).catch(unsuccessfulResponseHandler);
};
exports.fetchConfigFile = fetchConfigFile;
const fetchConfig = brandId => apiRequest.get(`brands/${brandId}/config`).then(successfulResponseHandler).catch(unsuccessfulResponseHandler);
exports.fetchConfig = fetchConfig;
const fetchBrandTranslations = (brandId, locale) => apiRequest.get(`translations/text-labels-per-brand/${brandId}/${locale || ''}`).then(successfulResponseHandler).catch(unsuccessfulResponseHandler);
exports.fetchBrandTranslations = fetchBrandTranslations;
const fetchSharedTranslations = locale => apiRequest.get(`translations/text-labels-common/${locale || ''}`).then(successfulResponseHandler).catch(unsuccessfulResponseHandler);
exports.fetchSharedTranslations = fetchSharedTranslations;
const fetchPlans = params => apiRequest.get('plans', {
  params
}).then(successfulResponseHandler).catch(unsuccessfulResponseHandler);
exports.fetchPlans = fetchPlans;
const fetchLinks = brandId => apiRequest.get(`brand/links?brand_id=${brandId}`).then(successfulResponseHandler).catch(unsuccessfulResponseHandler);
exports.fetchLinks = fetchLinks;
const createSubscription = (data, page) => apiRequest.post(`subscriptions${page ? `?page=${page}` : ''}`, data).then(successfulResponseHandler).catch(unsuccessfulResponseHandler);
exports.createSubscription = createSubscription;
const updateSubscription = (id, data) => apiRequest.patch(`subscriptions/${id}`, data).then(successfulResponseHandler).catch(unsuccessfulResponseHandler);
exports.updateSubscription = updateSubscription;
const changeSubscriptionActivation = (id, params) => apiRequest.post(`subscriptions/change-subscription-activation/${id}`, null, {
  params
}).then(successfulResponseHandler).catch(unsuccessfulResponseHandler);
exports.changeSubscriptionActivation = changeSubscriptionActivation;
const fetchSetupIntent = () => apiRequest.get('payments/intent').then(successfulResponseHandler).catch(unsuccessfulResponseHandler);
exports.fetchSetupIntent = fetchSetupIntent;
const attachPaymentMethod = (id, data) => apiRequest.post(`payment_methods/${id}/attach`, data).then(successfulResponseHandler).catch(unsuccessfulResponseHandler);
exports.attachPaymentMethod = attachPaymentMethod;
const logAnalytics = event => apiRequest.get(`analytics?event=${event}`).then(successfulResponseHandler).catch(unsuccessfulResponseHandler);
exports.logAnalytics = logAnalytics;
const updateCustomerAddress = (customerId, address, brandId) => apiRequest.patch(`/stripe/${customerId}/set_address`, {
  brand_id: brandId,
  address
}).then(successfulResponseHandler).catch(unsuccessfulResponseHandler);
exports.updateCustomerAddress = updateCustomerAddress;
const deleteCustomer = token => apiRequest.delete(`/stripe/by-token/${token}`).then(successfulResponseHandler).catch(unsuccessfulResponseHandler);
exports.deleteCustomer = deleteCustomer;
const fetchPopups = _ref => {
  let {
    brandId
  } = _ref;
  return apiRequest.get(`/brand/popups?brand_id=${brandId}`).then(successfulResponseHandler).catch(unsuccessfulResponseHandler);
};
exports.fetchPopups = fetchPopups;
const authLogin = _ref2 => {
  let {
    brandId,
    username,
    password
  } = _ref2;
  return apiRequest.post('/sso/login', {
    brand_id: brandId,
    username,
    password
  }, {
    headers: formUrlencodedHeaders
  });
};
exports.authLogin = authLogin;
const authLogout = () => apiRequest.post('/sso/logout');
exports.authLogout = authLogout;
const authMe = () => apiRequest.get('/sso/me');
exports.authMe = authMe;
const authRefresh = _ref3 => {
  let {
    brandId,
    refreshToken
  } = _ref3;
  return apiRequest.post('/sso/refresh-token', {
    brand_id: brandId,
    refresh_token: refreshToken
  }, {
    headers: formUrlencodedHeaders
  });
};
exports.authRefresh = authRefresh;